import React, { useState } from "react";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { LANGS, ROLE_LABELS } from "../../lib/constants";
import AdminDialog, { Field, DialogButtons } from "./AdminDialog";

export default function UserProfileDialog({ user, onClose, onSaved }) {
  const isOwnerUser = user?.role === "owner";
  const [form, setForm] = useState({
    name: user?.name || "", email: user?.email || "", language: user?.language || "RU",
    telegram_id: user?.telegram_id || "", role: user?.role || "user",
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, telegram_id: form.telegram_id || null };
    const res = user
      ? await act(api.put(`/admin/users/${user.id}`, payload), "Профиль сохранён")
      : await act(api.post("/admin/users", payload), "Пользователь создан");
    if (res) onSaved();
  };

  const roles = isOwnerUser ? ["owner"] : ["admin", "moderator", "user"];
  return (
    <AdminDialog title={user ? "✏️ Профиль" : "➕ Новый пользователь"} description={user ? user.email : "Вход на сайт для пользователей появится в Части 4"} onClose={onClose} testid="user-profile-dialog">
      <form onSubmit={save} className="space-y-3">
        <Field label="Имя"><input required value={form.name} onChange={set("name")} data-testid="user-name-input" /></Field>
        <Field label="Email"><input required type="email" value={form.email} onChange={set("email")} data-testid="user-email-input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Язык">
            <select value={form.language} onChange={set("language")} data-testid="user-language-select">
              {LANGS.map((l) => <option key={l} value={l}>{l}</option>)}
            </select>
          </Field>
          <Field label="Роль">
            <select value={form.role} onChange={set("role")} disabled={isOwnerUser} data-testid="user-role-select">
              {roles.map((r) => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
            </select>
          </Field>
        </div>
        <Field label="Telegram ID"><input value={form.telegram_id} onChange={set("telegram_id")} data-testid="user-telegram-input" /></Field>
        <DialogButtons onClose={onClose} testid="user-profile" />
      </form>
    </AdminDialog>
  );
}
